<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="inputStyle">
      <span>{{ val }}</span>
      <el-button
        v-if="val === '不可更新'&& isedite"
        :disabled="!isedite"
        @click="handleEnter"
        size="mini"
        type="primary"
        style="margin-left: 30px"
      >
        {{ $t('page.UPDATE') }}
      </el-button>
      <span v-if="val === '不可更新' && isedite">{{tooltip}}</span>
    </div>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import PageModel from '../../models/page'
import { copy } from '../../utils/tool'

import _ from 'lodash'

export default {
  name: 'jtSingleSelect',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    minLength: {
      type: Number,
      default: 1,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    expression: {
      type: String,
      default: '',
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: this.maxLength >= 100 ? 'textarea' : 'text',
      rows: this.maxLength > 200 ? 8 : 5,
      val: this.value || '可更新',
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
        border:window.innerWidth > 768 ? 'none' : '1px solid #ccc',
        padding:window.innerWidth > 768 ? '0' : '5px',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      let msg = this.$t('page.UPDATE_CONFIRM_MSG')
      let title = this.$t('page.UPDATE_CONFIRM_TITLE')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
        callback: (action) => {
          if (action === 'confirm') {
            this.$emit('datas', null, '可更新')
          }
        },
      })
    },

    _validate(value) {
      const min = this.minLength
      const max = this.maxLength
      const minErrMsg = this.$t('input.MIN_LENGTH', { min })
      const maxErrMsg = this.$t('input.MAX_LENGTH', { max })
      Validator.isLength(value, { min }, minErrMsg)
      Validator.isLength(value, { max }, maxErrMsg)
    },
    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        let str1 = value.replace(/[\f\r\t]/g, '')
        this._validate(str1)
        this.val = str1
        this.$emit('datas', null, str1)
      } else {
        this.$emit('datas', null, value)
      }
    },
  },

  mounted() {},
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;

  label {
    line-height: 20px;
  }
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}

.xing {
  color: #fff;
  margin-right: 5px;
}

@media screen and (max-width: 768px) {
  .component-container {
    flex-wrap: wrap;

    label {
      margin-bottom: 8px;
      margin-left: -10px;
    }
  }
}
</style>
